import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { updateChoice } from "areas/product/store/actions"
import {
  ChoiceOption,
  GradientContainer,
  OptionPrice,
  OptionsSlider,
} from "areas/product/wizard-options/components"
import Image from "components/ui/image"
import { to_currency } from "helpers/number"
import { imageLookup } from "helpers/product/image-lookup"
import { filterProductOptions } from "helpers/product/product-filtering"
import { useNavigation } from "helpers/use-navigation"

const ChoiceOptions = ({ selectedValue, setChoice, rwFiltered, data }) => {
  const keyboardProps = useNavigation({ direction: "horizontal" })

  return (
    <OptionsSlider
      aria-label={`${data.heading.title} Options`}
      data-slider="true"
      role="radiogroup"
    >
      {rwFiltered.map((rw) => {
        const selected = selectedValue && selectedValue === rw.value
        return (
          <ChoiceOption
            aria-checked={selected}
            data-cy={`product-wizard-options-rw-${rw.value}`}
            data-display-image={rw.image}
            data-filters={JSON.stringify(rw.filters)}
            data-is-option="true"
            data-is-selected={selectedValue == rw.value}
            data-price={rw.price}
            data-sia={rw.sia}
            data-title={rw.value}
            data-value={rw.value}
            key={`sliderRingWidthOption-${rw.value}`}
            onClick={(e) => setChoice(data.pref, rw, e)}
            role="radio"
            tabIndex={selected ? 0 : -1}
            {...keyboardProps}
          >
            <div
              className="flex flex-col items-center justify-end"
              style={{ minHeight: "75px", minWidth: "75px" }}
            >
              <Image
                alt={rw.value}
                src={imageLookup("rw", rw.value, "regular")}
              />
              <span className="text-12 mt-8 pb-12 font-medium">{rw.value}</span>
            </div>

            <OptionPrice className="mt-5">
              {rw.price > 0 ? "(+" + to_currency(rw.price) + ")" : ""}
            </OptionPrice>
          </ChoiceOption>
        )
      })}
    </OptionsSlider>
  )
}

ChoiceOptions.propTypes = {
  data: PropTypes.object,
  rwFiltered: PropTypes.object,
  selectedValue: PropTypes.string,
  setChoice: PropTypes.func,
}

const InternalRingWidthOptions = ({
  data,
  selectedValue,
  filterParams,
  setChoice,
}) => {
  if (!data) {
    return null
  }

  const rwFiltered = filterProductOptions(data.options, filterParams, true)

  return (
    <GradientContainer className="tablet:px-15 tablet:pt-10 px-10">
      <FocusScope>
        <ChoiceOptions
          data={data}
          rwFiltered={rwFiltered}
          selectedValue={selectedValue}
          setChoice={setChoice}
        />
      </FocusScope>
    </GradientContainer>
  )
}

InternalRingWidthOptions.propTypes = {
  data: PropTypes.object,
  filterParams: PropTypes.object,
  selectedValue: PropTypes.string,
  setChoice: PropTypes.func,
}

const getFilterParams = (state) => {
  const pref = state.wizard.filters.rw ? state.wizard.filters.rw[0] : ""
  const value = pref ? state.choices[pref].value : ""
  return { pref, value }
}

const mapStateToProps = (state, ownProps) => {
  return {
    data: state.wizard.data.rw,
    filterParams: getFilterParams(state, ownProps),
    selectedValue: state.choices.rw ? state.choices.rw.value || "" : "",
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setChoice: (pref, data) => {
      dispatch(updateChoice(pref, data, true))
    },
  }
}

const RingWidthOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalRingWidthOptions)

export default RingWidthOptions
